// extracted by css-extract-rspack-plugin
export default {"banner":"LowQualityWarningBanner-module__banner__BtQtZdw","buttonContent":"LowQualityWarningBanner-module__buttonContent__KsarmVw"};